<template>
  <div>
    <v-container fluid>
      <div class="text-xs-right">
        <v-btn :loadin="exportloading" @click="exportData" color="grey" outline>
          <i class="fas fa-file-export"></i>
          &nbsp;
          {{ $t('export') }}&nbsp;
        </v-btn>
      </div>
      <div>
        <v-btn
          class="mx-0"
          @click="changeCampaign('ss4')"
          color="primary"
          :depressed="campaign == 'ss4'"
          :outline="campaign != 'ss4'"
        >
          โหวต 10สุดยอดอัจฉริยะพันธุ์จิ๋ว ซีซั่น 4
        </v-btn>
        <v-btn
          @click="changeCampaign('ss3')"
          color="primary"
          :depressed="campaign == 'ss3'"
          :outline="campaign != 'ss3'"
        >
          โหวต10โมเมนต์สุดประทับใจ
        </v-btn>
      </div>
      <div>
        <date-filter
          ref="datefilter"
          v-model="selectedDate"
          @changeDate="onDateChanged"
          :default-filter="''"
        ></date-filter>
      </div>
      <h5>ข้อมูลคะแนนโหวต</h5>
      <div v-if="!loading" style="margin: auto" :key="barchartkey">
        <template v-if="votedata">
          <div id="chart">
            <apexchart type="bar" height="400" :options="chartOptions" :series="series"></apexchart>
          </div>
          <div>
            <v-card>
              <v-card-text>
                <v-layout row wrap>
                  <v-flex xs6>
                    <div class="text-xs-center" style="font-weight: bold; color: grey">
                      คะแนนโหวตทั้งหมด
                    </div>
                    <div
                      class="text-xs-center"
                      style="font-weight: bold; color: #0057f5; font-size: 19px"
                    >
                      {{ votedata.total }}
                    </div>
                  </v-flex>
                  <v-flex xs6>
                    <div class="text-xs-center" style="font-weight: bold; color: grey">
                      จำนวนคนโหวตทั้งหมด
                    </div>
                    <div
                      class="text-xs-center"
                      style="font-weight: bold; color: #0057f5; font-size: 19px"
                    >
                      {{ votedata.total_user }}
                    </div>
                  </v-flex>
                </v-layout>
              </v-card-text>
            </v-card>
          </div>
          <div>
            <v-card>
              <v-card-text>
                <v-layout row wrap justify-center>
                  <v-flex xs12 md4 class="pr-3">
                    <apexchart
                      width="100%"
                      type="pie"
                      :options="chartOptionsAge"
                      :series="seriesAge"
                    ></apexchart
                  ></v-flex>
                  <v-flex xs12 md4 class="pr-3">
                    <apexchart
                      type="pie"
                      width="100%"
                      :options="chartOptionsGender"
                      :series="seriesGender"
                    ></apexchart>
                  </v-flex>
                  <v-flex xs12 md4>
                    <apexchart
                      type="pie"
                      width="100%"
                      :options="chartOptionsProvinceGroup"
                      :series="seriesProvinceGroup"
                    ></apexchart>
                  </v-flex>
                  <v-flex xs12 md12 class="pr-3">
                    <div
                      style="
                        color: grey;
                        font-weight: 400;
                        font-size: 18px;
                        font-family: 'Roboto';
                        text-align: center;
                      "
                    >
                      แยกตามจังหวัด
                    </div>
                    <v-card>
                      <div
                        class="pa-2 text-xs-center"
                        style="width: 100%; height: 100%; position: relative"
                      >
                        <div
                          style="width: 70%; height: 500px; margin-left: auto; margin-right: auto"
                          id="regions_div"
                        ></div>
                        <div
                          style="
                            position: absolute;
                            right: 5px;
                            top: 5px;
                            overflow: auto;
                            height: 94%;
                            width: 194px;
                            padding: 10px;
                          "
                        >
                          <div v-for="(item, k) in sortedMapData" :key="k">
                            <div
                              style="
                                display: flex;
                                justify-content: space-between;
                                color: cadetblue;
                              "
                            >
                              <div>
                                {{ item[0] }}
                              </div>
                              <div>
                                {{ item[1] }}
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </v-card>
                  </v-flex>
                </v-layout>
              </v-card-text>
            </v-card>
          </div>
        </template>
        <template v-else>
          <div
            style="text-align: center; font-size: 30px; color: #cccccc; margin-top: 45px"
            class="text-center"
          >
            ไม่มีข้อมูล
          </div>
        </template>
      </div>
      <div v-else>
        <dashboard-graph-loading></dashboard-graph-loading>
      </div>
    </v-container>
    <v-dialog v-model="popupmodal" persistent max-width="1000px">
      <div>
        <v-card>
          <div v-if="popuploading" class="text-xs-center" style="padding: 50px">
            <div class="spinner text-xs-center">
              <img class="z-loop" src="/static/img/assets/loading/z-loop.png" alt="loading" />
            </div>
          </div>
          <div v-else>
            <div class="text-xs-right">
              <v-btn @click="closePopup" icon>
                <v-icon>close</v-icon>
              </v-btn>
            </div>
            <div style="border-bottom: 1px solid #e5e5e5">
              <v-layout row wrap>
                <v-flex xs6>
                  <div class="text-xs-center" style="font-weight: bold; color: grey">
                    คะแนนโหวตทั้งหมด
                  </div>
                  <div
                    class="text-xs-center"
                    style="font-weight: bold; color: #0057f5; font-size: 19px"
                  >
                    {{ dialogData.total }}
                  </div>
                </v-flex>
                <v-flex xs6>
                  <div class="text-xs-center" style="font-weight: bold; color: grey">
                    จำนวนคนโหวตทั้งหมด
                  </div>
                  <div
                    class="text-xs-center"
                    style="font-weight: bold; color: #0057f5; font-size: 19px"
                  >
                    {{ dialogData.total_user }}
                  </div>
                </v-flex>
              </v-layout>
            </div>
            <v-card-text>
              <v-layout row wrap justify-center>
                <v-flex xs12 md4>
                  <apexchart
                    type="pie"
                    :options="chartOptionsPopupAge"
                    :series="seriesPopupAge"
                  ></apexchart
                ></v-flex>
                <v-flex xs12 md4>
                  <apexchart
                    type="pie"
                    :options="chartOptionsPopupGender"
                    :series="seriesPopupGender"
                  ></apexchart>
                </v-flex>
                <v-flex xs12 md4>
                  <apexchart
                    type="pie"
                    :options="chartOptionsPopupProvinceGroup"
                    :series="seriesPopupProvinceGroup"
                  ></apexchart>
                </v-flex>
                <v-flex xs12 md12 style="padding-bottom: 36px">
                  <div
                    style="
                      color: grey;
                      font-weight: 400;
                      font-size: 18px;
                      font-family: 'Roboto';
                      text-align: center;
                    "
                  >
                    แยกตามจังหวัด
                  </div>
                  <v-card>
                    <div
                      class="pa-2 text-xs-center"
                      style="width: 100%; height: 100%; position: relative"
                    >
                      <div
                        style="width: 70%; height: 400px; margin-left: auto; margin-right: auto"
                        id="regions_div_popup"
                      ></div>
                      <div
                        style="
                          position: absolute;
                          right: 5px;
                          top: 5px;
                          overflow: auto;
                          height: 94%;
                          width: 194px;
                          padding: 10px;
                        "
                      >
                        <div v-for="(item, k) in sortedMapDataPopup" :key="k">
                          <div
                            style="display: flex; justify-content: space-between; color: cadetblue"
                          >
                            <div>
                              {{ item[0] }}
                            </div>
                            <div>
                              {{ item[1] }}
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </v-card>
                </v-flex>
              </v-layout>
              <div class="mt-8">
                <v-data-table
                  expand
                  style="position: relative; bottom: 50px"
                  v-bind:pagination.sync="commentPagination"
                  :headers="headers"
                  :rows-per-page-items="[10, 25, 45, { text: $t('All'), value: -1 }]"
                  :rows-per-page-text="$t('Rows per page')"
                  :items="dialogData.userlist"
                  class="elevation-1 scgallrenttable"
                >
                  <template v-slot:items="props">
                    <tr>
                      <td class="text-xs-center">{{ props.item.name }}</td>
                      <td class="text-xs-center">
                        {{ props.item.vote_date | dateFormat('DD/MM/YYYY HH:mm') }}
                      </td>
                    </tr>
                  </template>
                </v-data-table>
              </div>
            </v-card-text>
          </div>
        </v-card>
      </div>
    </v-dialog>
  </div>
</template>

<script>
import api from '@/api'
import DateFilter from './DateFilter.vue'
import { mapGetters } from 'vuex'
import dayjs from 'dayjs'
import apexchart from 'vue-apexcharts'
import DashboardGraphLoading from './DashboardGraphLoading'
import collect from 'collect.js'
import Province from './SupertenProvince.js'
import XLSX from 'xlsx'
export default {
  components: {
    DateFilter,
    apexchart,
    DashboardGraphLoading
  },
  data() {
    return {
      votedata: '',
      commentPagination: { sortBy: 'value', descending: true, rowsPerPage: 10 },
      headers: [
        {
          align: 'center',
          text: this.$t('ชื่อ'),
          value: 'name'
        },
        {
          align: 'center',
          text: this.$t('วันที่โหวต'),
          value: 'vote_date'
        }
      ],
      barchartkey: '',
      loading: true,
      popuploading: false,
      popupmodal: false,
      totaluserSeries: [],
      dialogData: {},
      seriesGender: [],
      seriesAge: [],
      seriesYears: [],
      seriesProvince: [],
      seriesProvinceGroup: [],
      seriesPopupGender: [],
      seriesPopupAge: [],
      seriesPopupYears: [],
      seriesPopupProvince: [],
      seriesPopupProvinceGroup: [],
      series: [
        {
          name: 'vote',
          data: []
        }
      ],
      chartOptions: {
        title: {
          text: 'คะแนนโหวต',
          align: 'center',
          style: {
            fontSize: '18px',
            fontWeight: 'bold',
            fontFamily: 'Roboto',
            color: 'grey'
          }
        },
        chart: {
          events: {
            dataPointSelection: this.barclick
          },
          height: 650,
          width: '100%',
          type: 'bar'
        },
        theme: {
          palette: 'palette1' // upto palette10
        },
        plotOptions: {
          bar: {
            distributed: true,
            dataLabels: {
              position: 'right' // top, center, bottom
            }
          }
        },
        dataLabels: {
          enabled: true,
          formatter: function(val) {
            return val
          },
          offsetY: -20,
          style: {
            fontSize: '12px',
            colors: ['#304758']
          }
        },

        xaxis: {
          categories: [],
          position: 'bottom',
          axisBorder: {
            show: false
          },
          axisTicks: {
            show: false
          },
          crosshairs: {
            fill: {
              colors: ['#F44336', '#E91E63', '#9C27B0']
            }
          },
          tooltip: {
            enabled: true
          }
        },
        yaxis: {
          axisBorder: {
            show: false
          },
          axisTicks: {
            show: false
          }
        }
      },
      chartOptionsPopupGender: {
        legend: {
          position: 'right',
          horizontalAlign: 'right',
          width: 140,
          offsetY: 20,
          floating: true
        },
        plotOptions: {
          pie: {
            size: 60,
            offsetX: -50
          }
        },
        title: {
          text: 'แยกตามเพศ',
          align: 'center',
          style: {
            fontSize: '18px',
            fontWeight: 'bold',
            fontFamily: 'Roboto',
            color: 'grey'
          }
        },
        chart: {
          width: '100%',
          type: 'pie'
        },
        labels: ['ผู้ชาย', 'ผู้หญิง']
      },
      chartOptionsPopupAge: {
        legend: {
          position: 'right',
          horizontalAlign: 'right',
          width: 140,
          offsetY: 20,
          floating: true
        },
        plotOptions: {
          pie: {
            size: 60,
            offsetX: -50
          }
        },
        title: {
          text: 'แยกตามช่วงอายุ',
          align: 'center',
          style: {
            fontSize: '18px',
            fontWeight: 'bold',
            fontFamily: 'Roboto',
            color: 'grey'
          }
        },
        chart: {
          width: '100%',
          type: 'pie'
        },
        labels: []
      },
      chartOptionsPopupYears: {
        legend: {
          position: 'right',
          horizontalAlign: 'right',
          width: 140,
          offsetY: 20,
          floating: true
        },
        plotOptions: {
          pie: {
            size: 60,
            offsetX: -50
          }
        },
        title: {
          text: 'แยกตามปีเกิด',
          align: 'center',
          style: {
            fontSize: '18px',
            fontWeight: 'bold',
            fontFamily: 'Roboto',
            color: 'grey'
          }
        },
        chart: {
          width: '100%',
          type: 'pie'
        },
        labels: []
      },
      chartOptionsPopupProvince: {
        legend: {
          position: 'right',
          horizontalAlign: 'right',
          width: 170,
          offsetY: 20,
          floating: true
        },
        plotOptions: {
          pie: {
            size: 60,
            offsetX: -50
          }
        },
        title: {
          text: 'แยกตามจังหวัด',
          align: 'center',
          style: {
            fontSize: '18px',
            fontWeight: 'bold',
            fontFamily: 'Roboto',
            color: 'grey'
          }
        },
        chart: {
          width: '100%',
          type: 'pie'
        },
        labels: []
      },
      chartOptionsPopupProvinceGroup: {
        legend: {
          position: 'right',
          horizontalAlign: 'right',
          width: 200,
          offsetY: 20,
          floating: true
        },
        plotOptions: {
          pie: {
            size: 60,
            offsetX: -50
          }
        },
        title: {
          text: 'แยกตามภาค',
          align: 'center',
          style: {
            fontSize: '18px',
            fontWeight: 'bold',
            fontFamily: 'Roboto',
            color: 'grey'
          }
        },
        chart: {
          width: '100%',
          type: 'pie'
        },
        labels: []
      },
      chartOptionsAge: {
        legend: {
          position: 'right',
          horizontalAlign: 'right',
          width: 140,
          offsetY: 20,
          floating: true
        },
        plotOptions: {
          pie: {
            offsetX: -50,
            size: 80
          }
        },
        title: {
          text: 'แยกตามช่วงอายุ',
          align: 'center',
          style: {
            fontSize: '18px',
            fontWeight: 'bold',
            fontFamily: 'Roboto',
            color: 'grey'
          }
        },
        chart: {
          width: '100%',
          type: 'pie'
        },
        labels: []
      },
      chartOptionsYears: {
        legend: {
          position: 'right',
          horizontalAlign: 'right',
          width: 140,
          offsetY: 20,
          floating: true
        },
        plotOptions: {
          pie: {
            offsetX: -50,
            size: 80
          }
        },
        title: {
          text: 'แยกตามปีเกิด',
          align: 'center',
          style: {
            fontSize: '18px',
            fontWeight: 'bold',
            fontFamily: 'Roboto',
            color: 'grey'
          }
        },
        chart: {
          width: '100%',
          type: 'pie'
        },
        labels: []
      },
      chartOptionsGender: {
        legend: {
          position: 'right',
          horizontalAlign: 'right',
          width: 140,
          offsetY: 20,
          floating: true
        },
        plotOptions: {
          pie: {
            offsetX: -50,
            size: 80
          }
        },
        title: {
          text: 'แยกตามเพศ',
          align: 'center',
          style: {
            fontSize: '18px',
            fontWeight: 'bold',
            fontFamily: 'Roboto',
            color: 'grey'
          }
        },
        chart: {
          width: '100%',

          type: 'pie'
        },
        labels: []
      },
      chartOptionsProvinceGroup: {
        legend: {
          position: 'right',
          horizontalAlign: 'right',
          width: 200,
          offsetY: 20,
          floating: true
        },
        plotOptions: {
          pie: {
            offsetX: -50,
            size: 80
          }
        },
        title: {
          style: {
            fontSize: '18px',
            fontWeight: 'bold',
            fontFamily: 'Roboto',
            color: 'grey'
          },
          text: 'แยกตามภาค',
          align: 'center'
        },
        chart: {
          width: '100%',

          type: 'pie'
        },
        labels: []
      },

      selectedDate: {
        start: dayjs().format('YYYY-MM-DD HH:mm'),
        end: dayjs().format('YYYY-MM-DD HH:mm')
      },
      data: [],
      mapData: [],
      mapDataPopup: [],
      campaign: 'ss4',
      selectedDate: {
        start: '2021-01-30',
        end: '2021-02-11'
      },
      chart: null,
      chartPopup: null,
      exportloading: false
    }
  },
  computed: {
    sortedMapData() {
      return this.mapData.sort((a, b) => {
        return b[1] - a[1]
      })
    },
    sortedMapDataPopup() {
      return this.mapDataPopup.sort((a, b) => {
        return b[1] - a[1]
      })
    },
    ...mapGetters(['selectedBot'])
  },
  async mounted() {
    await this.getData()
    google.load('visualization', '1', { packages: ['geochart'] })
    google.setOnLoadCallback(this.drawRegionsMap)
  },
  methods: {
    exportData: function(offset = 0) {
      this.exportloading = true
      var data = [
        [],
        ['คะแนนโหวตทั้งหมด', '', '', '', '', 'จำนวนคนโหวตทั้งหมด', '', '', '', ''],
        [this.votedata.total, '', '', '', '', this.votedata.total_user, '', '', '', ''],

        [
          'ข้อมูลคะแนนโหวต',
          '',

          'แยกตามช่วงอายุ',
          '',
          'แยกตามเพศ',
          '',
          'แยกตามภาค',
          '',
          'แยกตามจังหวัด',
          ''
        ],
        ['หมายเลข', 'จำนวน', 'อายุ', 'จำนวน', 'เพศ', 'จำนวน', 'ภาค', 'จำนวน', 'จังหวัด', 'จำนวน']
      ]

      /* merge cells A1:B1 */
      var merge = [
        { s: { r: 2, c: 0 }, e: { r: 2, c: 4 } },
        { s: { r: 2, c: 5 }, e: { r: 2, c: 9 } },
        { s: { r: 1, c: 0 }, e: { r: 1, c: 4 } },
        { s: { r: 1, c: 5 }, e: { r: 1, c: 9 } },
        { s: { r: 3, c: 0 }, e: { r: 3, c: 1 } },
        { s: { r: 3, c: 2 }, e: { r: 3, c: 3 } },
        { s: { r: 3, c: 4 }, e: { r: 3, c: 5 } },
        { s: { r: 3, c: 6 }, e: { r: 3, c: 7 } },
        { s: { r: 3, c: 8 }, e: { r: 3, c: 9 } },
        { s: { r: 3, c: 10 }, e: { r: 3, c: 11 } }
      ]
      //var merge = XLSX.utils.decode_range("A1:B1"); // this is equivalent

      /* generate worksheet */
      var ws = XLSX.utils.aoa_to_sheet(data)
      XLSX.utils.sheet_add_aoa(
        ws,
        this.chartOptions.xaxis.categories.map((el, k) => [el, this.series[0].data[k]]),
        { origin: 'A6' }
      )

      XLSX.utils.sheet_add_aoa(
        ws,
        this.chartOptionsAge.labels.map((el, k) => [el, this.seriesAge[k]]),
        { origin: 'C6' }
      )

      XLSX.utils.sheet_add_aoa(
        ws,
        this.chartOptionsGender.labels.map((el, k) => [el, this.seriesGender[k]]),
        { origin: 'E6' }
      )
      XLSX.utils.sheet_add_aoa(
        ws,
        this.chartOptionsProvinceGroup.labels.map((el, k) => [el, this.seriesProvinceGroup[k]]),
        { origin: 'G6' }
      )
      XLSX.utils.sheet_add_aoa(ws, this.mapData, { origin: 'I6' })
      // XLSX.utils.sheet_add_aoa(
      //   ws,
      //   this.chartOptionsProvince.labels.map((el, k) => [el, this.seriesProvince[k]]),
      //   { origin: 'H3' }
      // )

      /* add merges */
      if (!ws['!merges']) ws['!merges'] = []
      ws['!merges'] = merge

      /* generate workbook */
      var wb = XLSX.utils.book_new()
      XLSX.utils.book_append_sheet(wb, ws, 'sheet1')

      /* generate file and download */
      const wbout = XLSX.write(wb, { type: 'array', bookType: 'xlsx' })
      saveAs(
        new Blob([wbout], { type: 'application/octet-stream' }),
        `votedata_${dayjs().format('YYYYDDMM')}.xlsx`
      )
      this.exportloading = false
    },
    drawRegionsMap(id = 'regions_div') {
      var vm = this
      var mapdata
      if (id == 'regions_div_popup') {
        mapdata = vm.mapDataPopup
      } else {
        mapdata = vm.mapData
      }
      var data = google.visualization.arrayToDataTable([['จังหวัด', 'จำนวนโหวต'], ...mapdata])
      var options = {
        region: 'TH',
        resolution: 'provinces',
        //displayMode: 'markers',
        colorAxis: { colors: ['white', '#00a5ff', '#2655ff', '#7c00b2'] }
      }

      if (id == 'regions_div_popup') {
        this.chartPopup = new google.visualization.GeoChart(document.getElementById(id))

        this.$nextTick(() => {
          vm.chartPopup.draw(data, options)
        })
      } else {
        this.chart = new google.visualization.GeoChart(document.getElementById(id))

        this.$nextTick(() => {
          vm.chart.draw(data, options)
        })
      }
    },
    async changeCampaign(ss) {
      this.$refs.datefilter.clearCurrentFilter()
      this.campaign = ss
      if (ss == 'ss3') {
        this.selectedDate.start = '2020-12-25'
        this.selectedDate.end = '2021-01-01'
      } else if (ss == 'ss4') {
        this.selectedDate.start = '2021-01-30'
        this.selectedDate.end = '2021-02-11'
      }
      await this.getData()
      this.drawRegionsMap('regions_div')
    },
    closePopup() {
      this.popupmodal = false
    },
    barclick(e, a, item) {
      this.getCompetitor(this.chartOptions.xaxis.categories[item.dataPointIndex])
    },
    getCompetitor(id) {
      var vm = this
      vm.popupmodal = true
      vm.popuploading = true
      api.superjeewrankedvotingBycompetitorid(
        {
          pageid: vm.selectedBot.pageid,
          competitorid: id,
          datefrom: vm.selectedDate.start,
          dateto: vm.selectedDate.end
        },
        (err, response) => {
          if (response && response.responsecode == 200 && response.data) {
            vm.dialogData = response.data[0]
            const collectionAge = collect(vm.dialogData.years)
            const collectionGender = collect(vm.dialogData.gender)
            const collectionprovince = collect(vm.dialogData.province)
            var agesvalue = collectionAge.values().all()
            var ageskey = collectionAge
              .keys()
              .all()
              .map((el, index) => {
                return {
                  age: parseInt(new Date().getFullYear()) - parseInt(el),
                  value: agesvalue[index]
                }
              })
            var groupedAge = vm.groupBy(ageskey, function(x) {
              return Math.floor(x / 10)
            })
            var result = groupedAge.map(el => {
              var label = Math.ceil((el[0].age + 1) / 10) * 10
              var resultlabel = label - 9 + '-' + label + ' ปี'
              return {
                label: label ? resultlabel : 'ไม่ระบุ',
                series: el.reduce((a, b) => {
                  return a + b.value
                }, 0)
              }
            })
            vm.chartOptionsPopupAge.labels = result.map(el => el.label)
            vm.seriesPopupAge = result.map(el => el.series)

            var gendervalue = collectionGender.values().all()
            var genderkey = collectionGender
              .keys()
              .all()
              .map((el, index) => el + `: ${gendervalue[index]} คน`)
            vm.chartOptionsPopupGender.labels = genderkey
            vm.seriesPopupGender = gendervalue

            var provincevalue = collectionprovince.values().all()
            var provincekey = collectionprovince
              .keys()
              .all()
              .map((el, index) => el + `: ${provincevalue[index]} คน`)
            vm.chartOptionsPopupProvince.labels = provincekey
            vm.seriesPopupProvince = provincevalue

            var provincegroupvalue = [0, 0, 0, 0, 0, 0]
            vm.mapDataPopup = []
            for (const [key, value] of Object.entries(response.data[0].province)) {
              vm.mapDataPopup.push([key, value])
              if (Province.north.includes(key)) {
                provincegroupvalue[0] += value
              } else if (Province.northeast.includes(key)) {
                provincegroupvalue[1] += value
              } else if (Province.central.includes(key)) {
                provincegroupvalue[2] += value
              } else if (Province.east.includes(key)) {
                provincegroupvalue[3] += value
              } else if (Province.west.includes(key)) {
                provincegroupvalue[4] += value
              } else if (Province.south.includes(key)) {
                provincegroupvalue[5] += value
              }
            }
            var provincegroupkey = [
              'ภาคเหนือ' + `: ${provincegroupvalue[0]} คน`, //0
              'ภาคตะวันออกเฉียงเหนือ' + `: ${provincegroupvalue[1]} คน`, //1
              'ภาคกลาง' + `: ${provincegroupvalue[2]} คน`, //2
              'ภาคตะวันออก' + `: ${provincegroupvalue[3]} คน`, //3
              'ภาคตะวันตก' + `: ${provincegroupvalue[4]} คน`, //4
              'ภาคใต้' + `: ${provincegroupvalue[5]} คน` //5
            ]

            vm.chartOptionsPopupProvinceGroup.labels = provincegroupkey
            vm.seriesPopupProvinceGroup = provincegroupvalue
          }
          vm.popuploading = false
          vm.drawRegionsMap('regions_div_popup')
        }
      )
    },
    groupBy(ary, keyFunc) {
      var r = {}
      ary.forEach(function(x) {
        var y = keyFunc(x.age)
        r[y] = (r[y] || []).concat(x)
      })
      return Object.keys(r).map(function(y) {
        return r[y]
      })
    },
    sortAlphaNum(a, b) {
      var reA = /[^a-zA-Z]/g
      var reN = /[^0-9]/g

      var aA = a[0].replace(reA, '')
      var bA = b[0].replace(reA, '')
      if (aA === bA) {
        var aN = parseInt(a[0].replace(reN, ''), 10)
        var bN = parseInt(b[0].replace(reN, ''), 10)
        return aN === bN ? 0 : aN > bN ? 1 : -1
      } else {
        return aA > bA ? 1 : -1
      }
    },
    getData() {
      var vm = this
      return new Promise(resolve => {
        vm.loading = true
        api.superjeewrankedvoting(
          {
            pageid: vm.selectedBot.pageid,
            datefrom: vm.selectedDate.start,
            dateto: vm.selectedDate.end
          },
          (err, response) => {
            if (err.code == 'ECONNABORTED') {
              this.$swal
                .fire({
                  type: 'error',
                  text: 'ไม่สามารถโหลดข้อมูลได้ กรุณาลองใหม่อีกครั้ง'
                })
                .then(() => {
                  location.reload()
                })
            }
            if (response && response.responsecode == 200) {
              if (response.data && response.data.length) {
                this.votedata = response.data[0]
                // const collection = collect(response.data[0].competitor)
                const collectionAge = collect(response.data[0].years)
                const collectionGender = collect(response.data[0].gender)
                const collectionProvince = collect(response.data[0].province)

                var Competitors = []
                for (const [key, value] of Object.entries(response.data[0].competitor)) {
                  Competitors.push([key, value])
                }

                // console.log(CompetitorIds)
                var sortedCompetitor = Competitors.sort(vm.sortAlphaNum)
                this.series[0].data = sortedCompetitor.map(el => el[1])

                this.chartOptions.xaxis.categories = sortedCompetitor.map(el => el[0])
                var agesvalue = collectionAge.values().all()
                var ageskey = collectionAge
                  .keys()
                  .all()
                  .map((el, index) => {
                    return {
                      age: parseInt(new Date().getFullYear()) - parseInt(el),
                      value: agesvalue[index]
                    }
                  })
                var groupedAge = vm.groupBy(ageskey, function(x) {
                  return Math.floor(x / 10)
                })
                var result = groupedAge.map(el => {
                  var label = Math.ceil((el[0].age + 1) / 10) * 10
                  var resultlabel = label - 9 + '-' + label + ' ปี'
                  return {
                    label: label ? resultlabel : 'ไม่ระบุ',
                    series: el.reduce((a, b) => {
                      return a + b.value
                    }, 0)
                  }
                })
                vm.chartOptionsAge.labels = result.map(el => el.label)
                vm.seriesAge = result.map(el => el.series)

                var gendervalue = collectionGender.values().all()
                var genderkey = collectionGender
                  .keys()
                  .all()
                  .map((el, index) => el + `: ${gendervalue[index]} คน`)
                vm.chartOptionsGender.labels = genderkey
                vm.seriesGender = gendervalue

                var provincevalue = collectionProvince.values().all()
                var provincekey = collectionProvince
                  .keys()
                  .all()
                  .map((el, index) => el + `: ${provincevalue[index]} คน`)
                vm.seriesProvince = provincevalue

                var provincegroupvalue = [0, 0, 0, 0, 0, 0]
                vm.mapData = []
                for (const [key, value] of Object.entries(response.data[0].province)) {
                  vm.mapData.push([key, value])
                  if (Province.north.includes(key)) {
                    provincegroupvalue[0] += value
                  } else if (Province.northeast.includes(key)) {
                    provincegroupvalue[1] += value
                  } else if (Province.central.includes(key)) {
                    provincegroupvalue[2] += value
                  } else if (Province.east.includes(key)) {
                    provincegroupvalue[3] += value
                  } else if (Province.west.includes(key)) {
                    provincegroupvalue[4] += value
                  } else if (Province.south.includes(key)) {
                    provincegroupvalue[5] += value
                  }
                }
                var provincegroupkey = [
                  'ภาคเหนือ' + `: ${provincegroupvalue[0]} คน`, //0
                  'ภาคตะวันออกเฉียงเหนือ' + `: ${provincegroupvalue[1]} คน`, //1
                  'ภาคกลาง' + `: ${provincegroupvalue[2]} คน`, //2
                  'ภาคตะวันออก' + `: ${provincegroupvalue[3]} คน`, //3
                  'ภาคตะวันตก' + `: ${provincegroupvalue[4]} คน`, //4
                  'ภาคใต้' + `: ${provincegroupvalue[5]} คน` //5
                ]
                vm.chartOptionsProvinceGroup.labels = provincegroupkey
                vm.seriesProvinceGroup = provincegroupvalue

                this.barchartkey = new Date().getTime()
              } else {
                this.votedata = null
              }
              this.loading = false
              resolve()
            }
          }
        )
      })
    },
    async onDateChanged() {
      this.campaign = ''
      await this.getData()
    }
  }
}
</script>

<style lang="scss" scoped></style>



// WEBPACK FOOTER //
// src/components/view/analytics/SupertenDashboard.vue